"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconArrowDownOutline = _interopRequireDefault(require("./IconArrowDownOutline"));
var IconArrowUpOutline = /*#__PURE__*/(0, _styledComponents.default)(_IconArrowDownOutline.default).withConfig({
  displayName: "IconArrowUpOutline",
  componentId: "c11n-8-107-0__sc-eeafzz-0"
})(["transform:rotate(180deg);"]);
var _default = IconArrowUpOutline;
exports.default = _default;